import { useSetSearchParams } from '@hook/useSetSearchParams';
import { fetchData } from '@network/querys';
import classNames from 'classnames';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ICategoryProp {
    watchD1: string;
    watchD2: string;
    title: string;
    path: string;
    ga360str: string;
    activeCategory1: string | null;
    activeCategory2: string | null;
    submitCallback?: (d1: string, d2: string) => void;
}

export interface ICategoryData {
    id: string;
    name: string;
    child: Array<{
        id: string;
        name: string;
    }>;
}

export const Category = ({ props }: { props: ICategoryProp }) => {
    const { watchD1, watchD2, title, path, submitCallback, ga360str, activeCategory1, activeCategory2 } = props;
    const setParams = useSetSearchParams();
    const [dat, datSet] = useState<ICategoryData[]>([]);
    const [depth, depthSet] = useState<{ d1: string | null; d2: string | null }>({ d1: null, d2: null });
    const { t } = useTranslation();

    useEffect(() => {
        fetchData(path).then((res: ICategoryData[]) => datSet(res));
    }, [path]);

    useEffect(() => {
        const d1 = activeCategory1 ?? '';
        const d2 = activeCategory2 ?? '';
        depthSet({ d1, d2 });
    }, [activeCategory1, activeCategory2]);

    const onClickCategory = (e: React.MouseEvent<HTMLButtonElement>) => {
        const targ = e.currentTarget as HTMLElement;
        const d1 = targ.dataset.d1 ?? '';
        const d2 = targ.dataset.d2 ?? '';
        setParams({
            page: '',
            [watchD1]: d1,
            [watchD2]: d2,
        });
        submitCallback?.(d1, d2);
    };

    return (
        <section className="category">
            <header>{title}</header>
            <article>
                <button className="btn-category" data-d1="" data-d2="" onClick={onClickCategory}>
                    {t('common.all')}
                </button>
                <ul>
                    {dat.map((it, idx) => (
                        <li data-dep={it.id} key={'cate' + idx} className={classNames({ 'is-active': it.id === depth.d1 })}>
                            <button
                                className="btn-category"
                                data-d1={it.id}
                                data-areas="시세_조건검색_카테고리_클릭"
                                data-contents={it.name}
                                onClick={onClickCategory}
                            >
                                {it.name}
                            </button>
                            <ul>
                                {it.child?.map((sub, subidx) => (
                                    <li
                                        data-dep={`${it.id}-${sub.id}`}
                                        key={'cate' + idx + subidx}
                                        className={classNames({ 'is-active': it.id === depth.d1 && sub.id === depth.d2 })}
                                    >
                                        <button
                                            className="btn-category"
                                            data-d1={it.id}
                                            data-d2={sub.id}
                                            data-areas={ga360str}
                                            data-contents={`${it.name}-${sub.name}`}
                                            onClick={onClickCategory}
                                        >
                                            {sub.name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </article>
        </section>
    );
};
